import Accordion from '@bit/pitcher.components.accordion'

window.addEventListener('load', () => {
	const footerAccordion = document.querySelectorAll('.footer__columns');
	for (let i = 0; i < footerAccordion.length; i++) {
		const accordion = footerAccordion[i];
		new Accordion(accordion, {
			classNames: {
				accordionItem: '.footer__column',
				accordionHeader: '.footer__title',
				accordionContent: '.wrap'
			},
			multiSelectable: true,
			initialOpen: 'none'
		})
	}

	const accordions = document.querySelectorAll('.o-accordion');
	for (let i = 0; i < accordions.length; i++) {
		const accordion = accordions[i];
		new Accordion(accordion, {
			classNames: {
				accordionItem: '.o-accordion__item',
				accordionHeader: '.o-accordion__question',
				accordionContent: '.o-accordion__answer'
			},
			multiSelectable: false,
			initialOpen: 'none'
		})
	}
})



// WEBPACK FOOTER //
// ./js/modules/content/accordion.js